<template>
<div class="main" @click="toggle">

	<video @timeupdate="onProgress" @ended="onEnd" poster="@/assets/about.png" class="video">
		<source src="@/assets/home.mp4" type="video/mp4">
	</video>

	<div class="center" :class="{visible: !playing}">
		<!-- <img class="title" src="@/assets/title.png"> -->
		<div class="subtitle">Делайте гастрономические открытия<br>вместе с Aqua Minerale<br>с соком!</div>
	</div>

	<!-- <img src="@/assets/logo.png" class="logo"> -->

	<div class="play" :class="{visible: !playing}">
		<div class="triangle" />
	</div>

	<img class="arrow" :class="{visible: !playing}" src="@/assets/arrow_down.png">

</div>
</template>


<script>

export default {
	name: 'Video',
	data() {
		return {
			playing: false,
			v10: false,
			v20: false,
			v30: false,
			v40: false,
			v50: false,
		}
	},

	mounted() {
		this.video = this.$el.querySelector('.video')
	},
	methods: {
		toggle() {
			if (this.playing) this.video.pause()
			else this.video.play()
			this.playing = !this.playing
			if (window.gtag) {
				if (this.playing) gtag('event', `home video play`)
				else gtag('event', `home video pause`)
			}
		},
		onProgress(e) {
			let sec = e.timeStamp / 1000
			if (!this.v10 & sec > 10) {
				this.v10 = true
				if (window.gtag) gtag('event', `home video 10s`)
			}
			if (!this.v20 & sec > 20) {
				this.v20 = true
				if (window.gtag) gtag('event', `home video 20s`)
			}
			if (!this.v30 & sec > 30) {
				this.v30 = true
				if (window.gtag) gtag('event', `home video 30s`)
			}
			if (!this.v40 & sec > 40) {
				this.v40 = true
				if (window.gtag) gtag('event', `home video 40s`)
			}
			if (!this.v50 & sec > 50) {
				this.v50 = true
				if (window.gtag) gtag('event', `home video 50s`)
			}
		},
		onEnd() {
			this.playing = false
			if (window.gtag) gtag('event', `home video ended`)
		},
	},
}
</script>


<style lang="less" scoped>
@import "../assets/app.less";

.main {
	width: 100vw;
	height: 100vh;
	// background-image: url('../assets/home.png');
	background: #000;
	background-size: cover;
	background-position: center;
	color: #fff;
}

video {
	width: 100vw;
	height: 100vh;
	position: absolute;
	top: 0;
	left: 0;
	object-fit: cover;

	// video {
	// 	object-fit: cover;
	// 	width: 100vw;
	// 	height: 100vh;
	// 	// position: fixed;
	// 	top: 0;
	// 	left: 0;
	// }
}

.center {
	width: 100%;
	height: 100%;
	display: flex;
	position: absolute;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	text-align: center;
	font-size: 20px;
	font-weight: 400;
	position: relative;
	transform: translateY(20vh);
	opacity: 0;
	pointer-events: none;
	transition: opacity 500ms ease;

	&.visible {
		opacity: 1;
		pointer-events: all;
	}

	.subtitle {
		position: absolute;
		left: 50%;
		bottom: 36%;
		line-height: 26px;
		transform: translateX(-50%);
	}

}

.arrow {
	position: absolute;
	left: 50%;
	transform: translateX(-50%);
	bottom: 5%;
	animation: bounce 1s infinite;
	opacity: 0;
	pointer-events: none;

	&.visible {
		opacity: 1;
		pointer-events: all;
	}
}

.logo {
	position: absolute;
	left: 30px;
	top: 20px;
	width: 220px;
}

.play {
	width: 100px;
	height: 100px;
	border: 2px solid #fff;
	border-radius: 50px;
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translateX(-50%) translateY(-50%);
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	opacity: 0;
	pointer-events: none;
	transition: opacity 500ms ease;

	&.visible {
		opacity: 1;
		pointer-events: all;
	}

	.triangle {
		width: 0;
		height: 0;
		border-top: 20px solid transparent;
		border-bottom: 20px solid transparent;
		border-left: 30px solid #fff;
	}
}


@keyframes bounce {
	0% {
		transform: translateX(-50%) translateY(0);
	}
	50% {
		transform: translateX(-50%) translateY(5px);
	}
	100% {
		transform: translateX(-50%) translateY(0);
	}
}



@media only screen and (max-width: 1000px) {

.logo {
	position: absolute;
	left: 20px;
	top: 20px;
	width: 100px;
}

.center {
	img.title {
		width: 90%;
		margin: 0 auto;
	}

	.subtitle {
		position: relative;
		left: 0%;
		bottom: 0%;
		line-height: 26px;
		transform: translateX(0%);
		font-size: 16px;
		line-height: 22px;
	}

	.arrow {
		margin-top: 20px;
	}
}



}



</style>